import styled from "styled-components";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const StyledUserMention = styled(Typography)``;

export const User = styled(Typography)`
  cursor: pointer;
  color: ${theme.colorsV2.shyft.purple_text};
`;
